import { createEl } from '../../tools/basic-functions.js';
import {
  addListenerSliderItemOptionEstimator,
  createSliderItemOptions,
  getSliderItemDescription
} from './utilities.js';

export async function createShopSliderItem(item) {
  const { getTranslation } = await import('../../tools/translations.js');

  let langLocale = _CMS_LOCALE != '' ? _CMS_LOCALE : _CMS_LANGUAGE,
    categoryTranslation = await getTranslation(item.category),
    shopItemUrl = `/${langLocale}/shop/${item.url}`,
    labelInner = item.label == 'popular' ? undefined : item.label == 'sale' ? '%' : await getTranslation(item.label),
    labelEl = item.label == 'none' || item.label == 'popular' ? '' : `<div class="label">${labelInner}</div>`,
    thumbEl = item.thumbnail
      ? `<img onerror="this.style.visibility=\'hidden\'" src="${item.thumbnail}" class="img-fluid">`
      : '',
    itemOpt = createSliderItemOptions(item);

  let domString = `
    <a class="panel swiper-slide" href="${shopItemUrl}">
        ${labelEl ? `<div class="panel-header">${labelEl}</div>` : ''}
            <div class="panel-wrapper d-flex">
                <div class="panel-thumb">
                    ${thumbEl}
                </div>
                ${itemOpt}
                <div class="panel-content d-flex">
                    <span class="badge">${categoryTranslation}</span>
                    <span class="panel-name">${item.title}</span>
                </div>
            </div>
            <div class="panel-footer">
                <div class="panel-footer-info">
                    ${await getSliderItemDescription(item)}
                </div>
            <div class="btn btn-gray btn-addToCard"></div>
        </div>
    </a>`;
  const itemEl = createEl(domString);

  if (item.estimator === 'true') {
    addListenerSliderItemOptionEstimator(itemEl, item);
  }

  return itemEl;
}

export function createShopItemsList(category, allShopItems = []) {
  if (category == 'popular') {
    return allShopItems.filter((t) => t.label === 'popular');
  } else if (category == 'other') {
    return allShopItems.filter((t) => [category, 'electronics'].includes(t.category)).reverse();
  } else if (category == 'super-energyspins') {
    return allShopItems.filter((t) => t.category === 'energyspins').reverse();
  }
  return allShopItems.filter((t) => t.category === category);
}
